import React, { useState } from 'react';
import { Paper } from '@mui/material';
import * as XLSX from 'xlsx';
import { useSelector } from 'react-redux';
import { triggerNotification } from '../../utils/NotificationContext';
import DynamicTable from '../../components/Table/Table';
import UploadModal from '../../components/Modals/Upload';

import { bulkUploadFile } from './servies';
const SteeringRecoTable = ({
  data,
  isTableLoading,
  checkedRows,
  editedFCRows,
  setCheckedRows,
  columns,
  currentVotingTeam,
  showCheckbox,
  setUploadStatusMsg,
  isUploadDownloadDisabled,
  currentActiveCycle,
  currentActiveCycleID,
  userType,
  userLevel,
  regionOption,
  customerFilter,
  filterPagination
}) => {
  const selectedBu = useSelector((state) => state?.cycle?.selectedBu);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  const handleDownload = async () => {
    try {
      const content = data;
      const columnIds = columns?.map((column) => column.id);
      // List of columns with new names to include in the download
      const transformedContent = content?.map((row) => {
        const newRow = {};
        columnIds?.forEach((columnId) => {
          const upperCaseColumnId = columnId?.toUpperCase(); // Convert column ID to uppercase
          if (columnId) {
            if (typeof row[columnId] === 'number') {
              newRow[upperCaseColumnId] = row[columnId]; // Keep numbers as they are
            } else {
              newRow[upperCaseColumnId] = row[columnId] !== undefined ? String(row[columnId]) : '';
            }
          }
          if (upperCaseColumnId === 'TAGGEDUSERS') {
            // If the columnId is taggedUsers, extract User Emails and join them into a string
            newRow[upperCaseColumnId] =
              row[columnId]?.map((user) => user.UserEmail)?.join(', ') || ''; // Join User Emails or return empty string
          } else if (
            upperCaseColumnId === 'FUNCTIONAL TEAM COMMENTS' ||
            upperCaseColumnId === 'COLLATED COMMENTS'
          ) {
            // If the columnId is REQUESTED INPUT FROM, flatten the array and join names into a string
            newRow[upperCaseColumnId] = row[columnId]?.join(', ') || ''; // Join names or return empty string
          } else if (
            upperCaseColumnId === 'AGREEDISAGREESTATUS' ||
            upperCaseColumnId === 'STEERING TEAM AGREEMENT' ||
            upperCaseColumnId.includes('AGREE STEERING TEAM RECO')
          ) {
            // Transform boolean value to "Like" or "Dislike"
            if (row[columnId] === null) {
              newRow[upperCaseColumnId] = '';
            } else if (row[columnId] === false) {
              newRow[upperCaseColumnId] = 'Disagree';
            } else {
              newRow[upperCaseColumnId] = 'Agree';
            }
          } else if (upperCaseColumnId === 'FUNCTIONAL TEAM VOTES') {
            // Convert functional team votes to a comma-separated string
            const upvotes = row[columnId]?.functionalteamupvotes || 0;
            const downvotes = row[columnId]?.functionalteamdownvotes || 0;
            newRow[upperCaseColumnId] = `${upvotes} Agree, ${downvotes} Disagree`; // Create a string with upvotes and downvotes
          } else if (row[columnId] === null) {
            newRow[upperCaseColumnId] = '';
          }
        });
        return newRow;
      });
      const updateKeyNames = (data) => {
        return data?.map((item) => {
          if (currentVotingTeam === 'Steering Reco') {
            const { AGREEDISAGREESTATUS, RECOMMENDATION, COMMENT, TAGGEDUSERS, ...rest } = item; // Extract keys to be renamed
            return {
              ...rest, // Retain all other fields
              'AGREE ACTION RECO': AGREEDISAGREESTATUS, // Add the renamed key
              'RECOMMENDATION(MAX 24 CHAR)': RECOMMENDATION, // Add the renamed key
              COMMENT,
              TAGGEDUSERS
            };
          } else if (currentVotingTeam === 'Functional Feedback') {
            const { AGREEDISAGREESTATUS, COMMENT, TAGGEDUSERS, ...rest } = item; // Extract keys to be renamed
            return {
              ...rest, // Retain all other fields
              'AGREE STEERING TEAM RECO': AGREEDISAGREESTATUS,
              COMMENT,
              TAGGEDUSERS
            };
          } else {
            const { AGREEDISAGREESTATUS, RECOMMENDATION, COMMENT, ...rest } = item; // Extract keys to be renamed
            return {
              ...rest, // Retain all other fields
              'AGREE STEERING TEAM RECO': AGREEDISAGREESTATUS,
              'RECOMMENDATION(MAX 24 CHAR)': RECOMMENDATION, // Add the renamed key
              COMMENT
            };
          }
        });
      };

      const updatedData = updateKeyNames(transformedContent);
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(updatedData);

      XLSX.utils.book_append_sheet(wb, ws, 'VotingData');
      // View only sheet
      let newSheetData = [];
      if (currentVotingTeam == 'Steering Reco') {
        newSheetData = [
          {
            BU: selectedBu,
            Cycle: currentActiveCycle,
            'AGREE ACTION RECO': 'It should be either Agree or Disagree',
            'RECOMMENDATION(MAX 24 CHAR)':
              'Mandatory only if Agree Action Recos is entered as Disagree',
            COMMENTS: 'Mandatory if Agree Action Reco is entered as Disagree'
          }
        ];
      } else if (currentVotingTeam == 'Functional Feedback') {
        newSheetData = [
          {
            BU: selectedBu,
            Cycle: currentActiveCycle,
            'AGREE STEERING TEAM RECO': 'It should be either Agree or Disagree',
            COMMENTS: 'Mandatory only if Agree Steering  Reco is entered as Disagree'
          }
        ];
      } else if (currentVotingTeam == 'Regional Decisions') {
        newSheetData = [
          {
            BU: selectedBu,
            Cycle: currentActiveCycle,
            Region: regionOption,
            'AGREE STEERING TEAM RECO': 'Mandatory enter either Agree or Disagree',
            'RECOMMENDATION(MAX 24 CHAR)':
              'Mandatory only if Agree Steering Team Reco is entered as Disagree',
            COMMENTS: 'Mandatory only if Agree Steering Team Reco is entered as Disagree'
          }
        ];
      }

      const newWs = XLSX.utils.json_to_sheet(newSheetData);

      XLSX.utils.book_append_sheet(wb, newWs, 'Info(View Only)');

      XLSX.writeFile(wb, `${selectedBu}_Voting_${currentVotingTeam}.xlsx`);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleBulkUpload = async (formData, onUploadProgress) => {
    if (formData) {
      await bulkUploadFile(formData, onUploadProgress)
        .then((res) => {
          if (res) {
            triggerNotification(res.message, 'success', 10000);
          }
          setUploadStatusMsg(res);
        })
        .catch((error) => {
          setUploadStatusMsg(error);
        })
        .finally(() => {
          setIsUploadModalOpen(false);
        });
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        borderRadius: '8px',
        backgroundColor: '#FBFCFE',
        boxShadow: '4px 0px 24px -2px #005CBC14'
      }}>
      <DynamicTable
        originalColumns={columns}
        originalData={data}
        tableName="Recommendation Table"
        isTableLoading={isTableLoading}
        isSearch={false}
        isColumnVisibleFilter
        isColumnFilter
        isGlobalFilter
        downloadExcel
        handleDownloadData={handleDownload}
        isBulkUpload
        onBulkUploadModalOpen={() => setIsUploadModalOpen(true)}
        isUploadDownloadDisabled={isUploadDownloadDisabled}
        isCollapseButton={false}
        density="small"
        showOverLayTable={false}
        showTableText={
          showCheckbox
            ? ''
            : currentVotingTeam === 'Functional Feedback'
              ? '*Fill the “Comment” field if you disagree with the Steering Reco.'
              : currentVotingTeam === 'Regional Decisions'
                ? '*Fill the “Recommendation & Comment” field if you disagree with the Steering team Reco.'
                : '*Fill the “Recommendation” field if you disagree with the Agree Action Reco'
        }
        isRowChecked
        editedFCRows={editedFCRows}
        checkedRows={checkedRows}
        setCheckedRows={setCheckedRows}
        currentVotingTeam={currentVotingTeam}
        showCheckbox={showCheckbox}
        customerFilter={customerFilter}
        filterPagination={filterPagination}
      />
      {isUploadModalOpen && (
        <UploadModal
          open={isUploadModalOpen}
          handleOpen={() => setIsUploadModalOpen(true)}
          handleClose={() => setIsUploadModalOpen(false)}
          onUploadFile={handleBulkUpload}
          mode="single"
          userType={userType}
          userLevel={userLevel}
          currentActiveCycleID={currentActiveCycleID}
          regionOption={regionOption}
          pageId={'Voting'}
          data-testid="upload-modal"
        />
      )}
    </Paper>
  );
};

export default SteeringRecoTable;
